// @flow
import * as React from 'react';
import { SubmitButton, ObservationButton } from '../../Common';
import {
  actionAside as actionAsideCss,
  actionAsideSecondOpinionButton as actionAsideSecondOpinionButtonCss,
  actionAsideSectionCustomObservationHeader as actionAsideCOHeadingCss,
  actionAsideSectionMerchantNameSubheader as actionAsideMerchantNameHeadingCss,
} from './ActionAside.scss';
import ActionAsideSection from './ActionAsideSection';
import { Observation } from 'models';

const ActionAsideUnmoderated = (props: {
  pending: boolean,
  selectedCount: number,
  onSubmit: Function,
  onSecondOpinionClick: Function,
  standardObservationButtons: Array<React.Element<any>>,
  customObservationButtons: Array<React.Element<any>>,
  merchantName: string,
}) => {
  const {
    pending = false,
    onSubmit,
    onSecondOpinionClick,
    selectedCount,
    standardObservationButtons,
    customObservationButtons,
    merchantName,
  } = props;

  return (
    <div className={actionAsideCss}>
      <ActionAsideSection.First>
        <SubmitButton
          pending={pending}
          onClick={onSubmit}
          label={selectedCount === 0 ? 'No Comment, Next' : 'Done, Next'}
          className="w-100"
        />
      </ActionAsideSection.First>

      {customObservationButtons.length > 0 && (
        <ActionAsideSection>
          <h3 className={actionAsideCOHeadingCss}>Custom Observations for:</h3>
          <p className={actionAsideMerchantNameHeadingCss}>{merchantName}</p>
          {customObservationButtons}
        </ActionAsideSection>
      )}
      <ActionAsideSection heading={`Standard Observations`}>
        {standardObservationButtons}
      </ActionAsideSection>
      <ActionAsideSection>
        <ObservationButton
          onClick={onSecondOpinionClick}
          name="Get a Second Opinion"
          observation_type_code={Observation.SecondOpinionCode}
          className={actionAsideSecondOpinionButtonCss}
        />
      </ActionAsideSection>
    </div>
  );
};

export default ActionAsideUnmoderated;



// WEBPACK FOOTER //
// ./src/components/ModerationCard/PowerReviewsModerationCard/ActionAsideUnmoderated.js